import React from "react";
import ProductFields from "@/components/valuator/ProductFields";
import ConditionPanel from "@/components/valuator/ConditionPanel";
import QuickRangePanel from "@/components/valuator/QuickRangePanel";

export const ValuatorStep1 = ({ vf, onCategoryChange, quickRange, quickLoading, onQuickRange, step1Valid, onNext }) => (
  <div data-testid="wizard-step-1" className="grid grid-cols-1 lg:grid-cols-12 gap-6">
    <ProductFields vf={vf} onCategoryChange={onCategoryChange} />
    <ConditionPanel form={vf.form} update={vf.update} />
    <QuickRangePanel
      quickRange={quickRange}
      quickLoading={quickLoading}
      onQuickRange={onQuickRange}
      step1Valid={step1Valid}
      onNext={onNext}
    />
  </div>
);

export default ValuatorStep1;
